import AppliedFilters from './AppliedFilters';

export default AppliedFilters;
